import { Component } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

export interface ISiteMapConfirmDeleteData {
    message: string;
    varX: number;
    varY: number;
    confirmTextToInput: string;
    yesButtonText: string;
}

@Component({
    selector: 'fi-site-map-confirm-delete',
    templateUrl: './site-map-confirm-delete.component.html',
    styleUrls: ['./site-map-confirm-delete.component.scss'],
    standalone: false,
})
export class SiteMapConfirmDeleteComponent extends FiDialogsContentBase<ISiteMapConfirmDeleteData, boolean> {
    confirmText: string = '';

    ngOnInit() {}

    isYesButtonDisabled() {
        return this.confirmText !== this.data.confirmTextToInput;
    }

    getYesButtonText() {
        return this.data.yesButtonText;
    }
}
